/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol, TextField } from 'sarsaparilla';
import get from 'lodash/get';
import SelectInput from './inputs/SelectInput';
import { PassTypeProps } from '../props';

export default class VehicleInfoForm extends Component {
    static defaultProps = {
        isScannedPass: false,
        skipCustomerInfo: false,
    };

    static propTypes = {
        isScannedPass: PropTypes.bool,
        skipCustomerInfo: PropTypes.bool,
        number: PropTypes.number,
        submitAttempted: PropTypes.bool,
        passType: PassTypeProps,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        const vTypes = props?.passType?.features['equipment-info'].vehicle;
        const vTypesKeys = Object.keys(vTypes);
        this.state = {
            vehicleType: vTypesKeys[0],
            licenseNumber: get(this.props, 'vehicleInfo.fields.license', ''),
        };
    }

    componentDidMount() {
        const vehicleTypes = Object.keys(
            get(this.props.passType, ['features', 'equipment-info', 'vehicle'])
        );

        this.props.onChange(
            {
                ...this.state.vehicleType,
                fields: { license: this.state.licenseNumber },
                type: vehicleTypes[0],
            },
            this.formIsValid()
        );
    }

    onVehicleTypeChanged = (vehicleType) => {
        const licenseNumber = this.getDefaultLicenseNumber(vehicleType);

        this.setState(
            (prevState) => ({ ...prevState, vehicleType, licenseNumber }),
            () => {
                this.props.onChange(
                    {
                        type: vehicleType,
                        fields: { license: licenseNumber },
                    },
                    this.formIsValid()
                );
            }
        );
    };

    onLicenseNumberChanged = (licenseNumber) => {
        this.setState(
            (prevState) => ({ ...prevState, licenseNumber }),
            () => {
                this.props.onChange(
                    { type: this.state.vehicleType, fields: { license: licenseNumber } },
                    this.formIsValid()
                );
            }
        );
    };

    getDefaultLicenseNumber = (vehicleType) => {
        const { license_required } = get(
            this.props,
            `passType.features['equipment-info']['vehicle']['${vehicleType}']`,
            {}
        );
        return license_required ? '' : 'N/A';
    };

    isMissingLicenseNumber(number, vehicleType) {
        const licenseRequired = get(this.props.passType, [
            'features',
            'equipment-info',
            'vehicle',
            vehicleType,
            'license_required',
        ]);

        if (!licenseRequired) {
            return false;
        }

        return number === '';
    }

    formIsValid() {
        const { vehicleType, licenseNumber } = this.state;
        return !this.isMissingLicenseNumber(licenseNumber, vehicleType);
    }

    render() {
        const { isScannedPass, number, passType, submitAttempted, skipCustomerInfo } =
            this.props;

        const { vehicleType } = this.state;
        let { licenseNumber } = this.state;
        if (!licenseNumber) {
            licenseNumber = this.getDefaultLicenseNumber(vehicleType);
        }
        const vehicleTypes = get(passType, ['features', 'equipment-info', 'vehicle']);
        const vehicleInfo = vehicleTypes[vehicleType] || {};

        if (!vehicleTypes) {
            return null;
        }

        const licenseRequired = get(vehicleInfo, 'license_required');

        return (
            <FlexRow className={isScannedPass ? 'scanned-pass' : ''}>
                <FlexCol xl="auto">
                    <SelectInput
                        required={!skipCustomerInfo}
                        label="Vehicle Type"
                        id={`vehicle-type-${number}`}
                        value={skipCustomerInfo ? '' : vehicleType}
                        options={[
                            ...Object.entries(vehicleTypes).map(
                                ([value, { name: label }]) => ({ label, value })
                            ),
                        ]}
                        onChange={this.onVehicleTypeChanged}
                        disabled={skipCustomerInfo}
                    />
                </FlexCol>
                <FlexCol xl="auto">
                    <TextField
                        isRequired={skipCustomerInfo ? false : licenseRequired}
                        label="License Plate Number"
                        id={`vehicle-license-${number}`}
                        data-testid={`vehicle-license-${number}`}
                        value={skipCustomerInfo ? '' : licenseNumber}
                        disabled={skipCustomerInfo || !licenseRequired}
                        shouldValidateOnUpdate={submitAttempted}
                        onChange={(e) => this.onLicenseNumberChanged(e.target.value)}
                    />
                </FlexCol>
            </FlexRow>
        );
    }
}

// cspell:ignore testid
